import moment from "moment";
import Swal from "sweetalert2";
import * as imageConversion from 'image-conversion';
export const filterDurationTime = (s, e) => {
      let x = moment(s);
      let y = moment(e);  //当下时间
      let duration = moment.duration(y.diff(x, 'ms'));   //做差
      let days = duration.get('days');
      let hours = duration.get('hours');
      let mins = duration.get('minutes');
      let ss = duration.get('seconds');
      return `${days}d ${hours}h ${mins}min ${ss}s`;
}
export const imageCompress = (file) => {
      return new Promise((resolve) => {
            //项目要求是大于10MB*1024的图片进行压缩，可根据项目情况自行判断
            let isLt600 = file.size > 10240 * 1024;
            if (isLt600) {
                  // 压缩到10240KB
                  Swal.fire({ title: "图片超过600KB,正在压缩中...", showConfirmButton: false });
                  Swal.showLoading();
                  imageConversion.compressAccurately(file, 10240).then(res => {
                        res = new File([res], file.name, { type: res.type, lastModified: Date.now() })
                        Swal.close();
                        resolve(res)
                  })
            } else {
                  resolve(file)
            }
      })
}

export const valueFormatter1 = (value,num=3) => {
      if (value == undefined || value === "" || isNaN(value)) {return '-'}
      if (value == null){ return 'null'}
      return Number(Number(value).toFixed(num))
      // let _value = Number(Math.abs(value))
      // if (_value > 0.01) {
      //       return Number(Number(value).toFixed(2)) 
      // } else if (_value > 0.001) {
      //       return Number(Number(value).toFixed(3)) 
      // } else if (_value > 0.0001) {
      //       return Number(Number(value).toFixed(4)) 
      // } else if (_value > 0.00001) {
      //       return Number(Number(value).toFixed(5)) 
      // } else {
      //       return Number(Number(value).toFixed(2)) 
      // }
};

export const randomColor = () => {
      let setColor = require('randomcolor');
      let color = setColor({
            luminosity: "light",
            hue: "blue",
      })
      return color
};

export const valueFormatter = (value) => {
      if (value == undefined || value == null || value == "") {
            return null
      }
      let _value = Math.abs(value)
      if (_value > 0.01) {
            return value.toFixed(2)
      } else if (_value > 0.001) {
            return value.toFixed(3)
      } else if (_value > 0.0001) {
            return value.toFixed(4)
      } else if (_value > 0.00001) {
            return value.toFixed(5)
      } else {
            return value.toFixed(2)
      }
};
export const formatNumber=(value)=>{
      if (value == undefined || value == null || value == "") {
            return null
      }
      // 检查是否为整数
      if (Number.isInteger(value)) {
            return value; // 直接返回整数
      } else if(value == 0){
            return value;
      } else {
            // 判断小数位数是否超过 2 位
            const decimalPart = value.toString().split(".")[1];
            if (decimalPart && decimalPart.length > 2) {
                  return value.toFixed(2); // 超过 2 位小数，保留小数点后 2 位
            } else {
                  return value; // 小数位不超过 2 位，直接返回原值
            }
      }
}
export const valueFormatterForHealth = (value,num=3) => {
      if (value == undefined || value == null || value === "") return null
      return Number(Number(value).toFixed(num)) 
      // let _value = Number(Math.abs(value))
      // if (_value > 0.01) {
      //       return Number(Number(value).toFixed(2)) 
      // } else if (_value > 0.001) {
      //       return Number(Number(value).toFixed(3)) 
      // } else if (_value > 0.0001) {
      //       return Number(Number(value).toFixed(4)) 
      // } else if (_value > 0.00001) {
      //       return Number(Number(value).toFixed(5)) 
      // } else {
      //       return Number(Number(value).toFixed(2)) 
      // }
};

// 判断值是否为空
export function isNull(val) {
      return val === null || val === void 0 || val === '' || (val).toString() === 'NaN'
}
/**
 * 取值
 * @val: 需要判断的值
 * @dt：为空时的默认值
 * @unit：单位
 * */
export function valStr(val, dt = '', unit = '', preUnit = '') {
      return isNull(val) ? dt : `${preUnit}${val}${unit}`
}
/**
 * 值保留小数处理
 * @val: 需要保留小数的值
 * @fixed：小数位数
 * @dt：为空时的默认值
 * @unit：单位
 * @preUnit: 前面的单位，如¥
 * */
export function valFixed(val, fixed = 3, dt = '', unit = '', preUnit = '') {
      return isNull(val) ? dt : `${preUnit}${parseFloat(val).toFixed(fixed)}${unit}`
}

/*
* 树形数据扁平化
* @param {any[]} arr 需要扁平化处理的数组
* @param {string} children 判断树形结构子集的字段
* @return 扁平化的一维数组，父子节点都收纳
* */
export function flatTreeList(arr=[], children = 'children'){
      return arr.reduce((preArr, nextItem) => {
            if(nextItem[children] && nextItem[children].length){
            return preArr.concat(nextItem, flatTreeList(nextItem[children], children))
            }else{
            preArr.push(nextItem)
            }
            return preArr
      }, [])
}

export function isIE() {
      const userAgent = window.navigator.userAgent;
      return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

/**
 * 文件下载
 * @param {*} link 下载链接
 * @param {*} name 下载的文件名称
 */
export function createADownload(link, name = '') {
      if (!isIE()) { // 非IE下载
      //   let a = document.createElement('a')
        // if (typeof a.download === 'undefined') {
        //   // var URL = window.URL || window.webkitURL;
        //   // var objectUrl = URL.createObjectURL(blob);
        //   window.location = link;
        // }else{
      //     a.href = link
      //     a.setAttribute('download', name)
      //     // a.setAttribute('target', '_blank')
      //     // a.click() // 在safari下不行。safari下的A标签默认是没有绑定事件的 Safari不支持非button元素的click事件
      //     document.body.appendChild(a); // 火狐浏览器必须追加到body里面
      //     var e = document.createEvent('MouseEvent');
      //     e.initEvent('click', false, false);
      //     a.dispatchEvent(e);
      //     setTimeout(()=>{
      //       a && document.body.removeChild(a)
      //     },2000)
      //   // }

        fetch(link).then(res => res.blob().then(blob => {
            let a = document.createElement('a');
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = name;
            document.body.appendChild(a); // 火狐浏览器必须追加到body里面
            a.click();
            window.URL.revokeObjectURL(url);
            a && document.body.removeChild(a)
        }))
      }else{
        window.open(link)
        /*
                 * For IE
                 * >=IE10
                 */
        // window.navigator.msSaveBlob(link, name);
      }
}

export function previewPdf(link){
      //   let a = document.createElement('a')
      //   a.target = '_blank'
      //   a.href= link
      //   document.body.appendChild(a); // 火狐浏览器必须追加到body里面
      //   a.click()
      //   a && document.body.removeChild(a)

        window.open(link, '_blank')
}


/**
 * echarts针对yAxis（min,max,boundaryGap）,促使echarts折线尽量垂直居中显示。对基本的数据情况做出处理
 * @param {*} arr 数据数组
 * @returns   Object{ key:min/max/boundaryGap, value:xxx }
 */ 
export function findYAxisMinMax(arr){
      let reslut = {} 
      if( arr[0] || arr[0] == 0 ){
        var min = Math.min(...arr)
        var max = Math.max(...arr)
        var diff = max - min
        // 获取到最小值，最大值
        if( diff > 0 && max > 0 && min > 0){ //正常数据
            if(diff>20){
                  reslut = { key:'boundaryGap', value:["50%","50%"] } 
            }else{
                  reslut = { key:'max', value:Math.ceil(max + min) } 
            }
        }else if(diff > 0 && max > 0 && min == 0){ //最小值为0时
            reslut = { key:'boundaryGap', value:["50%","50%"] } 
        }else if(diff > 0 && max > 0 && min < 0){ //有正有负
            reslut = { key:'boundaryGap', value:["50%","50%"] }  //
        }else if(diff == 0){ //数据相等
    
            if( max >0 && min > 0 ){//正数
                reslut ={ key:'max',  value:Math.ceil(max + min) }
            }else{//负数
                reslut ={ key:'min',  value:Math.ceil(max + min) }
            }
    
        }else{ //数据都为负数
            reslut =  { key:'min', value:Math.ceil(max + min)}
        }
      }
    
      return reslut;
  }